module.exports = ".main-header .logo .logo-lg {\n  margin-top: -5px;\n}\n.issue {\n  padding-top: 0px;\n  padding-bottom: 0px;\n  line-height: 12px;\n}"